/**
 * DeviceActionCard — one action on a This Device tab.
 *
 * TCA-26100804. Presentation only: the caller supplies the control, so the
 * handler and enable/disable expression it already had are moved, never
 * rewritten. A risky action is marked and states that a confirmation follows.
 */
import React from 'react';

export default function DeviceActionCard({
  icon = null,
  title,
  description = null,
  note = null,
  risky = false,
  children,
  testId = undefined,
}) {
  return (
    <div
      className={`rounded-xl border px-4 py-3 ${risky ? 'border-rose-200' : 'border-stone-200'} bg-white`}
      data-testid={testId}
    >
      <div className="flex items-start gap-3">
        {icon && (
          <span
            className={`mt-0.5 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg ${
              risky ? 'bg-rose-50 text-rose-700' : 'bg-stone-100 text-primary'
            }`}
            aria-hidden="true"
          >
            {icon}
          </span>
        )}
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-stone-800">{title}</p>
          {description && <p className="mt-0.5 text-xs text-stone-500">{description}</p>}
          <div className="mt-3">{children}</div>
          {note && <p className="mt-1 text-[11px] text-stone-500">{note}</p>}
        </div>
      </div>
    </div>
  );
}
